import { render, staticRenderFns } from "./InventoriesTable.vue?vue&type=template&id=7d37dc6f&scoped=true&"
import script from "./InventoriesTable.vue?vue&type=script&lang=ts&"
export * from "./InventoriesTable.vue?vue&type=script&lang=ts&"
import style0 from "./InventoriesTable.vue?vue&type=style&index=0&id=7d37dc6f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d37dc6f",
  null
  
)

export default component.exports